module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "content-c",
    attrs: {
      "id": "calibre_toc_5"
    }
  }, [_c('a', {
    attrs: {
      "id": "b3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_004#a3"
    }
  }, [_c('span', {
    staticClass: "bold5"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "16658.png",
      "src": "OEBPS/image/16658.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("My heartfelt gratitude pours out to the San Francisco Public Library. The library has provided me with the many materials used in my work over the years, as well as giving me a welcome platform for my wellness workshops. I have been a fan for years and will continue to support them, as they have done me a great"), _c('span'), _vm._v("service.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Thank you to Mango Publishing for taking a chance on me and my passions. I spent the first half of my life absorbing life lessons. I dedicate the second half of my life to giving through the world of words. With Brenda Knight as my editor, ally, angel, and mentor, I have grown in leaps and bounds. Thank you, Brenda. I am grateful to the CEO, Chris, and to the marketing and design team for working so patiently with me, as I didn’t know anything about that side of the business or the tech stuff. Heck, my kids had to teach me how to type and create a website a couple of years ago. I thought FB meant fall"), _c('span'), _vm._v("back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Thank you to my tribe of email and personal clients on the World Wide Web, as well as those of you who are in my face. Thank you to my followers on all of my social media and to the readers out there who take the time to give me feedback and ask real, pertinent questions that will help transform your lives for the better when you do apply the principles from my books to your own worlds. You all have put your trust and hope into my hands, and I do not take that"), _c('span'), _vm._v("lightly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("And finally, thank you to my family and friends. You have been my sounding board in the wee hours of the morning and my rocks of strength when my own personal $#!+ hit the fan. I pray I have not turned you all off from the prospect of writing your own book one day. It really is a remarkable process that is reminiscent of the yellow brick road. I love you"), _c('span'), _vm._v("all."), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f435382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/HappyHealthyYou_split_007.vue
// module id = 81
// module chunks = 0